import React from "react";
import { LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Space, Typography } from "antd";
import { useUser } from "../../contexts/UserContext";

const { Text } = Typography;

const EnhancedLoading = ({ showRetryInfo = false, showRefreshButton = false }) => {
  const { retryCount, refreshUserData } = useUser();

  if (!showRetryInfo && !showRefreshButton) {
    // Simple loading icon for Spin components
    return (
      <LoadingOutlined
        style={{
          fontSize: 24,
        }}
        spin
      />
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '200px',
      gap: '16px'
    }}>
      <LoadingOutlined
        style={{
          fontSize: 32,
          color: '#1890ff'
        }}
        spin
      />
      
      <Space direction="vertical" align="center" size="small">
        <Text style={{ fontSize: '16px' }}>正在加载用户信息...</Text>
        
        {showRetryInfo && retryCount > 0 && (
          <Text type="secondary" style={{ fontSize: '14px' }}>
            正在重试... (第 {retryCount} 次尝试)
          </Text>
        )}
        
        {showRefreshButton && retryCount > 0 && (
          <Button 
            type="link" 
            icon={<ReloadOutlined />}
            onClick={refreshUserData}
            style={{ marginTop: '8px' }}
          >
            手动重新加载
          </Button>
        )}
      </Space>
    </div>
  );
};

export default EnhancedLoading;
